import {
    IDocumentoTemplate,
    IDocumentoTemplateBody,
} from "../../../../Interfaces/Geral/GestaoDeCadastro/Documentos/DocumentosInterface";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function ListarDocumentosTemplateService() {
    return Service(
        Axios.get<Array<IDocumentoTemplate>>(
            `/home/documentos/listardocumentotemplate`
        )
    );
}

export async function CadastrarDocumentoTemplateService(
    requestBody: IDocumentoTemplateBody
) {
    return Service(
        Axios.post(`/home/documentos/cadastrardocumentotemplate`, requestBody)
    );
}

export async function AtualizarDocumentoTemplateService(
    requestBody: IDocumentoTemplateBody
) {
    return Service(
        Axios.put(`/home/documentos/atualizardocumentotemplate`, requestBody)
    );
}
